/**
 * Check Valid Password
 * @param {String} password
 * @return {String}
*/
const checkValidPassword = (password) => {
  if (password && password.length < 8) {
    return 'shortPassword';
  }
  return '';
};

export default checkValidPassword;